import { useState } from 'react';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';

import { Button } from '../..';
import { Avatar } from './Avatar';
import { ProfileLinks } from './ProfileLinks';

const Profile = (): JSX.Element => {
  const [open, setOpen] = useState(false);
  const { t } = useSharedTranslation(namespaces.caregiver);

  const handleProfileClick = (): void => setOpen(!open);
  const handleProfileBlur = (): void => setOpen(false);

  return (
    <div className='inline-block relative'>
      <Button
        aria-label={t('components.header.profileButton')}
        className='block align-middle hover:opacity-80 rounded-full w-9 h-9'
        onClick={handleProfileClick}
        onBlur={handleProfileBlur}
        id='profile-photo'
      >
        <Avatar />
      </Button>
      <div
        className={`absolute md:top-9 w-44 right-0 bg-white text-left text-sm py-1 border drop-shadow-md rounded mt-2 z-10 active:block ${
          open ? 'block' : 'hidden'
        }`}
      >
        <ProfileLinks />
      </div>
    </div>
  );
};

export default Profile;
